import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  hasActivity: {
    minHeight: 366,
    "& $tabPanel": {
      maxHeight: 323
    }
  },
  tabs: {
    minHeight: 42,
    borderBottom: "1px solid #eeeeee",
    "& .MuiTab-root": {
      minHeight: 42,
      minWidth: 72
    },
    "& .Mui-selected .MuiTab-wrapper": {
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      color: theme.palette.text.primary
    },
    "& .MuiTab-wrapper": {
      textTransform: "none",
      lineHeight: "normal"
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "#000000",
      height: 1
    }
  },
  tabAlert: {
    "& .MuiTab-wrapper": {
      position: "relative",
      width: "auto"
    },
    "& .MuiTab-wrapper:after": {
      content: "''",
      display: "block",
      width: 6,
      height: 6,
      backgroundColor: theme.palette.warning.dark,
      top: 0,
      position: "absolute",
      right: -10,
      borderRadius: "50%"
    }
  },
  tabPanel: {
    display: "flex",
    flex: "auto",
    flexDirection: "column",
    padding: 0,
    maxHeight: 187,
    position: "relative",
    "&[hidden]": {
      display: "none"
    }
  },
  activePanel: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  },
  section: {
    marginBottom: 24
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: 16,
    color: "#595a5a",
    marginBottom: 10
  },
  content: {
    marginBottom: 14
  },
  italicCell: {
    fontStyle: "italic"
  }
}));
